import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Chip, Typography } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { ExpandMore } from '@mui/icons-material';
import { Loader } from '../../../../../Loader';


export const CustomAccordion = withStyles(Accordion, theme => ({
  root: {
    '&.Mui-expanded': {
      margin: 'initial',

      '&:before': {
        opacity: 1,
      },
    },

    '&.Mui-expanded + &': {
      '&:before': {
        display: 'block'
      }
    },

    '&:last-child:after': {
      position: 'absolute',
      left: 0,
      bottom: -1,
      right: 0,
      height: 1,
      content: '""',
      opacity: 1,
      backgroundColor: theme.palette.divider,
    }
  }
}));

export const CustomAccordionSummary = withStyles(AccordionSummary, {
  root: {
    '&.Mui-expanded': {
      minHeight: 'initial',
    },
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    margin: '16px 0',

    '&.Mui-expanded': {
      margin: '16px 0',
    }
  }
});


export type PatientProfileInfoAccordionProps = {
  title: string;
  loading?: boolean;
  expandable?: boolean;
  initialExpanded?: boolean;
  compensateExpandableIcon?: boolean;
  chip?: React.ReactNode;
};


export const PatientProfileInfoAccordion: React.FC<PatientProfileInfoAccordionProps> = ({ expandable = true, compensateExpandableIcon = false, initialExpanded = false, ...props }) => {
  const [ opened, setOpened ] = React.useState(initialExpanded);
  const isExpandable = !!props.children && expandable;
  const expandableCompensation = (compensateExpandableIcon ? <Box width="24px" /> : null);

  return (
    <CustomAccordion
      elevation={0}
      expanded={opened}
      onChange={isExpandable ? (() => setOpened(!opened)) : undefined}
    >
      <CustomAccordionSummary
        style={{ cursor: isExpandable ? 'pointer' : 'default' }}
        expandIcon={isExpandable ? <ExpandMore /> : expandableCompensation}
      >
        <Typography style={{ fontSize: '18px' }}>
          {props.title}
        </Typography>
        {props.loading
          ? <Chip size="small" label={<Loader width="24px" size="12px" thickness={6} color="inherit" />} />
          : props.chip}
      </CustomAccordionSummary>
      {props.children && (
        <AccordionDetails>
          {props.children}
        </AccordionDetails>
      )}
    </CustomAccordion>
  );
};
